<template>
  <div class="">
    <div v-if="Object.keys(product).length > 0">
      <template v-if="showWhatsAppButtonsMessage != null">
        <a class="text-decoration-none btn btn-primary rounded-pill" target="_blank" :href="setLinkWhatsAppButton"
           v-t="`product.single.whats_app_button.button_text`"></a>
      </template>
      <template v-else>
        <div v-if="!isProductActive(product)" v-t="`product.timing`"></div>
        <div v-if="product.variation == 0">
          <div v-if="quantityStatus(product)" v-t="`product.out_of_quantity`"></div>
          <div v-else-if="checkCallingMode(product) && !checkProductHaveFormula(product)"
               v-t="`product.callText`"></div>
          <div v-else>


            <normal-product :product="product"/>


          </div>
        </div>

        <div v-if="product.variation == 1">
          <variation-product :showVariationProductImage="showVariationProductImage" :product="product"/>
        </div>
        <div v-if="product.variation == 2">
          <m-reservation-calendar1 :product="product"/>
        </div>
      </template>
    </div>

  </div>
</template>

<script>
/* todo check this component to other product after change link with router */
import {mapGetters} from 'vuex'
import {isProductActive} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Timing";
import {
  quantityStatus,
  checkCallingMode, checkProductHaveFormula,
} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/ShoppingCartFunctions'
import NormalProduct from "../../Product/SingleProductPrice3/NormalProduct";
import VariationProduct from "../../Product/SingleProductPrice3/VariationProduct";
import mReservationCalendar1 from "../../Reservation/Calendar/ReservationCalendar1.vue";

export default {
  name: "SingleProductPrice3",
  components: {
    NormalProduct,
    VariationProduct,
    mReservationCalendar1,
  },
  props: {
    product: {},
    showWhatsAppButtonsMessage: {
      default: null
    },
    showVariationProductImage: {
      default: false
    }

  },
  computed: {
    ...mapGetters({
      isAuthenticated: 'User/isAuthenticated',
      order: "ShoppingCart/getSidebarBasketData",
    }),
    setLinkWhatsAppButton() {
      let baseText = this.$t('product.single.whats_app_button.message_template', {product_name: this.product.name})
      let text = encodeURIComponent(baseText);
      let link = `https://wa.me/${this.showWhatsAppButtonsMessage}?text=${text}`;
      return link
    }
  },
  methods: {
    isProductActive,
    quantityStatus,
    checkCallingMode,
    checkProductHaveFormula,
  },
  data() {
    return {
      offer: 0,
      price: 0,
      sub_product: null,
      order_product: {},
      isProductInShoppingCart: false,
    }
  },
  watch: {
    '$route': {
      handler: function () {
        this.sub_product = null
        this.selectedFeature_1 = 'null'
        this.selectedFeature_2 = 'null'
        this.offer = 0
        this.price = 0
        this.isProductInShoppingCart = false
      },
    },
  }
}
</script>

<style scoped>

</style>